import { createRequestSender } from '@bigcommerce/request-sender';
import { getScriptLoader } from '@bigcommerce/script-loader';

import {
    BraintreeIntegrationService,
    BraintreeScriptLoader,
} from '@bigcommerce/checkout-sdk/braintree-utils';
import {
    CustomerStrategyFactory,
    toResolvableModule,
} from '@bigcommerce/checkout-sdk/payment-integration-api';

import ApplePayCustomerStrategy from './apple-pay-customer-strategy';
import ApplePaySessionFactory from './apple-pay-session-factory';

const createApplePayCustomerStrategy: CustomerStrategyFactory<ApplePayCustomerStrategy> = (
    paymentIntegrationService,
) => {
    const { getHost } = paymentIntegrationService.getState();
    const hostWindow = window;

    return new ApplePayCustomerStrategy(
        createRequestSender({ host: getHost() }),
        paymentIntegrationService,
        new ApplePaySessionFactory(),
        new BraintreeIntegrationService(
            new BraintreeScriptLoader(getScriptLoader(), hostWindow),
            hostWindow,
        ),
    );
};

export default toResolvableModule(createApplePayCustomerStrategy, [{ id: 'applepay' }]);
